import GetFetch from "../hooks/GetFetch";
import PutPostPatchFetch from "../hooks/PutPostPatchFetch";

const URL_postExhibits = '/v1/PostExhibit/GetPostExhibits';

export const fetchPostExhibits = async () => {
    try {
        const { Errors, Message, Success } =
            await GetFetch(URL_postExhibits);
        if (!Success) {
            throw new Error(Errors?.[0]?.Message || "Failed to fetch Post Exhibits.");
        }

        return Message.map(
            ({
                CLIN,
                PostExhibitId,
                Name,
                Comment,
                TaskOrderId,
                TaskOrderNumber,
                FiscalYear,
                StartDate,
                EndDate,
                ClonedPostExhibitId,
                TaskOrder,
                FeeType: { FeeTypeName } = {},
                PostExhibitStatus,
                Posts
            }) => {
                const {
                    VendorName = null,
                    ContractId = null,
                    RegionId = null,
                    TaskOrderTypeId = null,
                    TaskOrderNumber: Number = null,
                    ContractNumber = null,
                    PostExhibit: {
                        StartDate: PostExhibitStartDate = null,
                        EndDate: PostExhibitEndDate = null,
                        Building: {
                            Name: Building_Name = null,
                            RegionNumber = null,
                            SequenceNumber: BuildingSequenceNumber = null,
                            BuildingId = null
                        } = {}
                    } = {}
                } = TaskOrder || {};

                return {
                    CLIN,
                    PostExhibitId,
                    Name,
                    Comment,
                    TaskOrderId,
                    TaskOrderNumber,
                    FiscalYear,
                    Building_Name,
                    BuildingId,
                    BuildingSequenceNumber,
                    StartDate,
                    EndDate,
                    RegionId,
                    VendorName,
                    ContractId,
                    ContractNumber,
                    PostExhibitStartDate,
                    PostExhibitEndDate,
                    FeeTypeName,
                    PostExhibitStatus,
                    TaskOrderTypeId,
                    ClonedPostExhibitId,
                    Posts
                };
            }
        );
    } catch (error) {
        console.error("Error fetching post exhibits:", error);
        throw error;
    }
}

// Fetch user settings by userId
export const fetchUserSettings = async (userId, SETTING_NAME) => {
    const { Message, Success, Errors } = await GetFetch(`/v1/UserSettings/GetUserSetting?userEmail=${userId}&settingName=${SETTING_NAME}`);
    if (!Success) throw new Error(Errors?.[0]?.Message || "Failed to fetch user settings.");
    return Message;
};

// Update user settings
export const updateUserSettings = async (userSettings) => {
    const { Success, Errors } = await PutPostPatchFetch(
        "/v1/UserSettings/UpdateUserSetting",
        "POST",
        userSettings
    );
    if (!Success) throw new Error(Errors?.[0]?.Message || "Failed to update user settings.");
    return true;
};
